import React from 'react';

import { CookieConsentProvider } from './features/cookie-consent';
import { NewsletterProvider } from './features/newsletter';
import { StagingPreviewProvider } from './features/staging-preview';

/**
 * App-wide providers, shared by gatsby-browser.js and gatsby-ssr.js.
 *
 * Gatsby applies browser and SSR lifecycle APIs from two separate files, so a
 * wrapRootElement declared in only one of them leaves the other's render
 * without these providers — and any consumer hook then throws during server
 * rendering ("useStagingPreview must be used within StagingPreviewProvider").
 * Declaring the tree once here and re-exporting from both files makes that
 * drift impossible.
 *
 * All three providers render only their children in the default state (the
 * in-house cookie UI is off behind CONSENT_MANAGED_BY_GTM, and the newsletter
 * dialog emits no DOM while closed), so server output is unchanged.
 */
export const wrapRootElement = ({ element }) => {
  return (
    <StagingPreviewProvider>
      <CookieConsentProvider>
        <NewsletterProvider>
          {element}
        </NewsletterProvider>
      </CookieConsentProvider>
    </StagingPreviewProvider>
  );
};
